/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import styled from "@emotion/styled";
import { colors } from "../../theme";

const style = css`
    width: 100%;
    margin-top: 40px;
`;

const photoStyle = css`
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 25px 30px ${colors.neutral3};
`;

export const HeroPhoto = props => <img css={photoStyle} {...props} />;

export const CenteredHero = styled.img`
    margin: ${props => (props.marginTop ? `${props.marginTop}px` : "0px")} auto;
    ${props => props.width && `width: ${props.width}px;`}
`;

const HeroImage = props => <img css={style} {...props} />;

export default HeroImage;
